import FadeIn from './FadeIn';

const socialLinks = [
  { label: 'Instagram', url: 'https://instagram.com/lulo_lonke' },
  { label: 'SoundCloud', url: 'https://soundcloud.com/lulo_lonke' },
  { label: 'YouTube', url: 'https://www.youtube.com/@LuloLonke' },
  // { label: 'HearThis', url: 'https://hearthis.at/lulo-lonke' },
];

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section">
      <div className="section-inner">
        <FadeIn>
          <p className="contact-eyebrow">Step Into my World</p>
          <h2 className="contact-title display">
            Let's Create<br /><em>Something Real.</em>
          </h2>
          <p className="contact-sub">
            For bookings, collaborations, and creative partnerships — step into
            the world of Lulo Lonke.
          </p>
        </FadeIn>
        <FadeIn delay={0.15}>
          <div className="contact-links">
            <a
              href="mailto:lulolonke.music@gmail.com"
              className="contact-link primary"
              data-testid="contact-email"
            >
              Email for Bookings
            </a>
            {socialLinks.map(({ label, url }) => (
              <a
                key={label}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link secondary"
                data-testid={`contact-${label.toLowerCase()}`}
              >
                {label}
              </a>
            ))}
          </div>
        </FadeIn>
      </div>
      <div className="footer-line" data-testid="footer">
        &copy; 2026 Lulo Lonke — All Rights Reserved
        <span className="footer-credit">Site by Lulo Lonke</span>
      </div>
    </section>
  );
}
